export const SET_DATE = 'dateSelection';
export const SET_EMPRESA = 'empresa';
export const SET_CENTRO_CUSTO = 'centroCusto';
export const SET_PRODUTO = 'produto';
export const SET_PROJETO = 'projeto';
export const SET_RESPONSAVEL = 'responsavel';
export const SET_GRUPO = 'grupo';
export const SET_FORNECEDOR = 'fornecedor';
export const SET_SOLICITANTE = 'solicitante';
